import { BackgroundRadio } from '../../engine/audio/BackgroundRadio';

export class RadioPlayer {
  static renderCompact(): HTMLElement {
    const container = document.createElement('div');
    container.id = 'nav-radio-player';
    container.style.cssText = `
      display: flex;
      align-items: center;
      gap: 10px;
      padding: 4px 12px;
      background: rgba(30, 41, 59, 0.6);
      border: 1px solid rgba(99, 102, 241, 0.3);
      border-radius: 20px;
      margin-left: 12px;
    `;

    this.updateCompactHTML(container);
    return container;
  }

  private static updateCompactHTML(container: HTMLElement): void {
    const track = BackgroundRadio.currentTrack;
    const isPlaying = BackgroundRadio.playing;

    container.innerHTML = `
      <div style="display: flex; align-items: center; gap: 6px;">
        <span style="font-size: 1.1rem; ${isPlaying ? 'animation: pulse 1.5s infinite;' : ''}">📻</span>
        <div style="display: flex; flex-direction: column; max-width: 150px; overflow: hidden;">
          <span style="font-size: 0.78rem; font-weight: 800; color: #f8fafc; white-space: nowrap; text-overflow: ellipsis; overflow: hidden;" title="${track.title}">${track.title}</span>
          <span style="font-size: 0.65rem; color: #818cf8; font-weight: 700; white-space: nowrap;">${track.genre}</span>
        </div>
      </div>

      <div style="display: flex; align-items: center; gap: 4px;">
        <button id="nav-radio-play-btn" style="padding: 4px 8px; background: linear-gradient(135deg, #6366f1, #a855f7); color: #fff; border-radius: 6px; font-weight: 700; font-size: 0.75rem;" title="${isPlaying ? 'Duraklat' : 'Oynat'}">
          ${isPlaying ? '⏸' : '▶'}
        </button>

        <button id="nav-radio-next-btn" style="padding: 4px 8px; background: #334155; color: #f8fafc; border-radius: 6px; font-weight: 700; font-size: 0.75rem; border: 1px solid #475569;" title="Sonraki Şarkı (20 Parça)">
          ⏭️
        </button>
      </div>
    `;

    container.querySelector('#nav-radio-play-btn')?.addEventListener('click', () => {
      BackgroundRadio.toggle();
      this.updateCompactHTML(container);
    });

    container.querySelector('#nav-radio-next-btn')?.addEventListener('click', () => {
      BackgroundRadio.nextTrack();
      if (!BackgroundRadio.playing) {
        BackgroundRadio.play();
      }
      this.updateCompactHTML(container);
    });
  }
}
